export const PLATFORM_API_URL = 'https://pdf-api.aldoo.com'
export const PLATFORM_API_VERSION = 'v1'
export const STRIPE_API_KEY = 'pk_live_51KHlvMDqI0V60CRML2VsmmU7IlOLHaLEpFd6QGWtY7Y82HfApsxMSkm4C1EIzgH0xXT5puVRUo8vt1w075qxTLzC00OT57Wgj1'
export const APP_DOMAIN = 'translate.aldoo.com'
export const GOOGLE_ANALYTICS_ID = "G-M60KWEPP2L"
export const FACEBOOK_PIXEL = "3251282068520708"
export const SUPPORT_CHAT_API = "https://pdf-api.aldoo.com/v1/chat"

